import { Button, IconButton, InputAdornment } from '@material-ui/core';
import FormControlTextField from 'modules/common/FormControlTextField';
import { ReactComponent as IcSearch } from '../../../assets/icons/ic_search.svg';
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { some } from 'constants/constants';
import { checkDeviceType } from 'utils/helpers/helpers';

interface Props {
  onSearch(searchInput: string): void;
  results?: some;
}

const SearchBox = (props: Props) => {
  const { onSearch } = props;
  const intl = useIntl();

  const [searchInput, setSearchInput] = React.useState<string>('');

  return (
    <div
      style={
        checkDeviceType()?.device?.type === 'mobile'
          ? { display: 'flex', flexFlow: 'column', justifyContent: 'center' }
          : {
              marginTop: 10,
              display: 'flex',
              flexWrap: 'nowrap',
            }
      }
    >
      {checkDeviceType()?.device?.type === 'mobile' ? (
        <>
          <FormControlTextField
            style={{
              minWidth: '344px',
              minHeight: '48px',
              height: 'auto',
              padding: 0,
            }}
            id="searchInput"
            disableError
            placeholder={intl.formatMessage({ id: 'home.enterBookerCode' })}
            formControlStyle={{ margin: 0 }}
            value={searchInput}
            onChange={(e: any) => {
              setSearchInput(e.target.value);
            }}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 10 }}>
                <IconButton size="small" edge="start">
                  <IcSearch />
                </IconButton>
              </InputAdornment>
            }
            optional
          />
          <Button
            type="submit"
            variant="contained"
            color="secondary"
            size="large"
            disableElevation
            style={{ width: 344, height: 48, padding: 4 }}
            onClick={() => {
              onSearch(searchInput);
            }}
          >
            <FormattedMessage id="home.bookerSearch" />
          </Button>
        </>
      ) : (
        <>
          <FormControlTextField
            style={{
              marginRight: 12,
              width: '330px',
              minHeight: '48px',
              height: 'auto',
            }}
            id="searchInput"
            disableError
            placeholder={intl.formatMessage({ id: 'home.enterBookerCode' })}
            formControlStyle={{ margin: 0 }}
            value={searchInput}
            onChange={(e: any) => {
              setSearchInput(e.target.value);
            }}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 10 }}>
                <IconButton size="small" edge="start">
                  <IcSearch />
                </IconButton>
              </InputAdornment>
            }
            optional
          />
          <Button
            type="submit"
            variant="contained"
            color="secondary"
            size="large"
            disableElevation
            style={{
              width: 150,
              height: 48,
              padding: 4,
            }}
            onClick={() => {
              onSearch(searchInput);
            }}
          >
            <FormattedMessage id="home.bookerSearch" />
          </Button>
        </>
      )}
    </div>
  );
};

export default SearchBox;
